/**
 * resolves the resource level to an age
 */
let resolve = (level, range) => {
  if (range) {
    return ageRange(level)
  } else {
    return specificAge(level)
  }
}

/**
 * returns an age range for a level
 */
let ageRange = (level) => {
  switch (level) {
    case -1:
      return '4 - 5'
    case 0:
      return '5 - 6'
    case 1:
      return '6 - 7'
    case 2:
      return '7 - 8'
    case 3:
      return '8 - 9'
    case 4:
      return '9 - 10'
    case 5:
      return '10 - 11'
    case 6:
      return '11 - 12'
    case 7:
      return '12 - 13'
    case 8:
      return '13 - 14'
    case 9:
      return '14 - 15'
    case 10:
      return '15 - 16'
    case 11:
      return '16 - 17'
    case 12:
      return '17 - 18'
    case 13:
      return '18+'
    default:
      throw Error
  }
}

/**
 * returns a specific age for a level
 */
let specificAge = (level) => {
  switch (level) {
    case -1:
      return '4'
    case 0:
      return '5'
    case 1:
      return '6'
    case 2:
      return '7'
    case 3:
      return '8'
    case 4:
      return '9'
    case 5:
      return '10'
    case 6:
      return '11'
    case 7:
      return '12'
    case 8:
      return '13'
    case 9:
      return '14'
    case 10:
      return '15'
    case 11:
      return '16'
    case 12:
      return '17'
    case 13:
      return '18'
    default:
      throw Error
  }
}
export default {
  resolve
}
